<script setup lang="ts">
import type { ProfileList, Section } from '@/models'
import { toRefs, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const messages = {}

const { t } = useI18n({ messages })

const props = defineProps({
  section: {
    type: Object as PropType<Section>,
    default: () => {},
  },
})
const propRefs = toRefs(props)
// Create a local (typecast) reference to the data
const profileList = propRefs.section.value as ProfileList
</script>

<template>
  <div class="border-2 border-solid border-red-400">
    <p class="text-red-400">ProfileSection</p>
    <h3>
      {{ profileList.type === 'person' ? t('participants') : t('partners') }}
    </h3>
    <div class="grid grid-cols-3 gap-10 mt-8">
      <div
        v-for="(p, i) of profileList.profiles"
        :key="`profile-${i}`"
        class="flex flex-row items-center"
      >
        <div class="w-24 aspect-square" v-if="p.image">
          <img :src="p.image.url" alt="" class="rounded-full" />
        </div>
        <div class="ml-4">
          <p class="font-bold mb-1">{{ p.name }}</p>
          <p>{{ p.role }}</p>
          <p>{{ p.address }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
